// extracted by mini-css-extract-plugin
module.exports =  {"disabled":"style-module_disabled__tFPj5F5X5_V7xiKNVoIT"};